<app-confirm-dialog
   [visible]="!!confirmationMessage"
   variant="secondary"
   heading="Confirmation"
   [message]="confirmationMessage"
   cancelText="No"
   (confirmed)="confirmPendingAction()"
   (cancelled)="cancelPendingAction()">
</app-confirm-dialog>

<div class="sales-Quotations-responsive p-g-12">
   <div class="p-g-12 p-table-tecfolk-fix">
      <div class="p-g">
         <div class="p-g-12">
            <p-table [value]="sales" [rowHover]="true" [paginator]="true" [rows]="100" [responsive]="true"
               [loading]="loading" [first]="first" (onPage)="onPageChange($event)">
               <ng-template pTemplate="caption" style="text-align: left">
                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchByInvoiceNumberLabel")}}</span>
                           <input id="searchOrder" #searchOrder autocomplete="off" pinputtext=""
                              (keyup)="searchLocal(saleOrder.invoiceNumber, 'number')"
                              [(ngModel)]="saleOrder.invoiceNumber"
                              [Placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                              class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                          <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("fromLabel")}}</span>
                                <p-calendar class="p-calendar-from" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="from" [placeholder]='setLabel("fromDatePlaceholderLabel")'
                                    [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" >
                                </p-calendar>
                            </div>

                            <div class="filterFields">
                                <span class="fieldTitle">{{setLabel("toLabel")}}</span>
                                <p-calendar class="p-calendar-to" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="to" [placeholder]='setLabel("toDatePlaceholderLabel")'
                                    [inputStyle]="{'color':'#ffffff'}" name="joinDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" >
                                </p-calendar>
                            </div>
                            <div *ngIf="this.user.role === 'Admin'" class="filterFields">
                                <span class="fieldTitle">{{setLabel("selectCategoryLabel")}}</span>
                                <p-dropdown class="p-inputtext" [options]="categoryOptions"
                                    [(ngModel)]="selectedCategoryOption" (onChange)="dropdownChange()">
                                </p-dropdown>
                            </div>
                        <div class="reportMainBtn">
                            <div class="reportActions">
                            <app-action-button
                                variant="secondary"
                                size="sm"
                                text="Search"
                                icon="fa fa-search"
                                title="Search"
                                ariaLabel="Search"
                                [disabled]="loading"
                                (action)="getQuotations()">
                            </app-action-button>
                            <app-action-button
                                variant="secondary"
                                size="sm"
                                text="Clear"
                                icon="fa fa-eraser"
                                title="Clear"
                                ariaLabel="Clear"
                                [disabled]="loading"
                                (action)="clear()">
                            </app-action-button>
                            <app-action-button
                                variant="secondary"
                                size="sm"
                                text="Add New"
                                icon="pi pi-user-plus"
                                title="Add New"
                                ariaLabel="Add New"
                                routerLink="/point-of-sale"
                                [disabled]="loading">
                            </app-action-button>
                            </div>
                            <div class="reportTools">
                                <span [pTooltip]='setLabel("printTooltipLabel")' tooltipPosition="top" [disabled]="loading" [disabled]="!isData"
                                    (click)="printAllInvoice()"><i class="fa fa-print"></i></span>
                            </div>
                        </div>
                     </div>
                  </div>
               </ng-template>
               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("invoiceNumberLabel")}}</th>
                     <th style="max-width: 90px;">{{setLabel("invoiceDateLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("subTotalLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("discountLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("totalTaxLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("grandTotalLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("cashPaidLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("remainingBalanceLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("cashReturnedLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("categoryLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("actionLabel")}}</th>
                  </tr>
               </ng-template>
               <ng-template pTemplate="body" let-rowData>
                  <tr class="p-selectable-row" >
                     <td >
                        <div class="mobile-Lable">{{setLabel("invoiceNumberLabel")}}</div>

                        {{rowData.invoiceNumber}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("invoiceDateLabel")}}</div>

                        {{rowData.invoiceDate | date: 'd/M/yy, h:mm a'}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("subTotalLabel")}}</div>

                        {{rowData.subTotal | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("discountLabel")}}</div>

                        {{rowData.discount | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("totalTaxLabel")}}</div>

                        {{rowData.vatTax | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("grandTotalLabel")}}</div>

                        {{rowData.total | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("cashPaidLabel")}}</div>

                        {{rowData.paid | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("remainingBalanceLabel")}}</div>

                       {{ (rowData.remainingBalance ? rowData.remainingBalance : 0) | number:'1.0-0' }}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("cashReturnedLabel")}}</div>

                        {{rowData.returned | number:'1.0-0'}}
                     </td>
                        <td>
                            <div class="mobile-Lable"> {{setLabel("categoryLabel")}}</div>
                            {{rowData.category }}
                        </td>
                    <td style="text-align: center;">
                     <span class="mobile-Lable"> {{setLabel("actionLabel")}}</span>
                        <button *ngIf="user.role === 'Admin'"  pButton type="button" tooltipPosition="top" pTooltip="Cancel Quotation" style="margin-right: 5px;"
                            class="p-button-danger p-button" icon="fa fa-times" (click)="CancelQuotation(rowData)">
                        </button>
                        <button  pButton type="button" tooltipPosition="top" pTooltip="Confirm Quotation" icon="fa fa-check"
                            (click)="confirmQuotation(rowData)" style="margin-right: 5px;" class="p-button-success p-button">
                        </button>
                        <button  pButton type="button" tooltipPosition="top" pTooltip="View Quotation" icon="fa fa-eye"
                            (click)="viewSaleOrder(rowData)" style="margin-right: 5px;">
                        </button>
                    
                    </td>
                  </tr>
               </ng-template>
               <ng-template pTemplate="footer">
                  <tr><td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td style="font-size: 16px; font-weight: bold; text-align: center; border: 1px solid #ababab;" colspan="2">
                        {{setLabel("summaryLabel")}}
                     </td>
                  </tr>
                  <tr><td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td style="font-size: 16px; text-align: right; border: 1px solid #ababab; text-align: start;" colspan="1">
                        {{setLabel("totalCountLabel")}}
                     </td>
                     <td colspan="1" style="font-size: 16px; text-align: end; border: 1px solid #ababab;">
                        {{sales?.length}}
                     </td>
                  </tr>
                  <tr>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td class="salesEmptyDiv"></td>
                     <td colspan="1" style="border: 1px solid gray;">
                        {{setLabel("totalSalesLabel")}}
                     </td>
                     <td colspan="1" style="font-size: 16px; text-align: end; border: 1px solid #ababab;">
                       {{getTotalSales() | number:'1.0-0'}}
                     </td>
                  </tr>
               </ng-template>
               <ng-template pTemplate="emptymessage" let-columns>
                  <tr style="color: black;">
                     <td>
                        {{setLabel("noRecordFoundLabel")}}
                     </td>
                  </tr>
               </ng-template>

            </p-table>
         </div>
      </div>
   </div>
</div>
<div id="allInvoice" #allInvoice style="display: none;">
    <div class="invoice-box">

        <table>
            <tbody>
                <td style="vertical-align: middle;padding: 0px;"><img
                        [src]=" (this.company.bannerImage ? config.Server + 'assets/layout/images/companies/' + this.company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        onerror="this.src=(this.company.bannerImage ? config.Server + 'assets/layout/images/companies/' + this.company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        alt="Company Logo" style="width: 80%;"> </td>

                <td>
                    <div style="width: 438px;">{{branch.name}}</div>
                    <div style="width: 438px;">{{branch.address}}</div>
                    <div>
                        {{setLabel("phoneNo:Label")}} {{branch.phone}}
                    </div>
                    <div>
                        {{setLabel("created:Label")}} {{date | date: 'dd/MM/yyyy'}}
                    </div>
                </td>
            </tbody>
        </table>

        <table cellpadding="0" cellspacing="0">

            <tr class="information">
                <td colspan="4">
                    <table>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <table style="border-spacing: inherit;" class="tablerpt">
                    <tbody>
                        <tr style="background-color: black;color: white;text-align: center;">
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("invoiceNoLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("invoiceDateLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("productsLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("discountLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("taxLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("saleAmountLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("totalLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("cashPaidLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("remainingBalanceLabel")}}</td>
                            
                        </tr>
                        <tr class="item" *ngFor="let item of sales">
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.invoiceNumber}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.invoiceDate | date: 'medium'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                <div *ngFor="let product of item.products" style="margin-bottom:3px;">
                                    <b>{{ product.name }}</b>
                                    ({{ product.quantity }} × {{ product.unitPrice | number:'1.0-0' }})
                                    = {{ product.quantity * product.unitPrice | number:'1.0-0' }}
                                </div>
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.discount | number:'1.0-0'}}  
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.vatTax | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.subTotal | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.total | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.paid | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{ (item.remainingBalance ? item.remainingBalance : 0) | number:'1.0-0' }}
                        </tr>
                    </tbody>
                </table>
            </tr>
        </table>
        <table>
            <tbody>
                <tr>
                    <td>
                        <div class="logoDiv">
                            {{setLabel("poweredByLabel")}} &nbsp;
                            <a href="http://tecfolk.com/" target="_blank">
                                <img style="width:66px;"
                                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt="">
                            </a>
                        </div>
                    </td>
                 
                </tr>
            </tbody>
        </table>


    </div>
</div><div id="allInvoice" #allInvoice style="display: none;">
    <div class="invoice-box">

        <table>
            <tbody>
                <td style="vertical-align: middle;padding: 0px;"><img
                        [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        alt="Company Logo" style="width: 80%;"> </td>

                <td>
                    <div style="width: 438px;">{{branch.name}}</div>
                    <div style="width: 438px;">{{branch.address}}</div>
                    <div>
                        {{setLabel("phoneNo:Label")}} {{branch.phone}}
                    </div>
                    <div>
                        {{setLabel("created:Label")}} {{date | date: 'dd/MM/yyyy'}}
                    </div>
                </td>
            </tbody>
        </table>

        <table cellpadding="0" cellspacing="0">

            <tr class="information">
                <td colspan="4">
                    <table>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <table style="border-spacing: inherit;" class="tablerpt">
                    <tbody>
                        <tr style="background-color: black;color: white;text-align: center;">
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("invoiceNoLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("invoiceDateLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("productsLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("discountLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("taxLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("saleAmountLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("totalLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("cashPaidLabel")}}</td>
                        </tr>
                        <tr class="item" *ngFor="let item of sales">
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.invoiceNumber}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.invoiceDate | date: 'medium'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                              
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.discount | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.vatTax | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.subTotal | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.total | number:'1.0-0'}}
                            </td>
                            <td style="text-align: center; border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle; border-left: 1px solid gray;">
                                {{item.paid | number:'1.0-0'}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </tr>
        </table>
        <table>
            <tbody>
                <tr>
                    <td>
                        <div class="logoDiv">
                            {{setLabel("poweredByLabel")}} &nbsp;
                            <a href="http://tecfolk.com/" target="_blank">
                                <img style="width:66px;"
                                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt="">
                            </a>
                        </div>
                    </td>
                    
                </tr>
            </tbody>
        </table>


    </div>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
   <p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
</ngx-spinner>